import { Link } from "react-router-dom";
import type { Article } from "@/mocks/content";
import { mangaList } from "@/mocks/manga";

export default function NewsReader({ article }: { article: Article }) {
  return (
    <div className="mx-auto max-w-3xl">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          className="aspect-[16/10] w-full object-cover"
        />
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        <span className="rounded-md bg-primary-100 px-2 py-1 font-medium text-primary-700">{article.category}</span>
        <span className="flex items-center gap-1"><i className="ri-calendar-line"></i>{article.date}</span>
        {article.tags.map((t) => (
          <span key={t} className="rounded-md bg-secondary-100 px-2 py-1 text-secondary-900">{t}</span>
        ))}
      </div>

      <article className="mt-6">
        <p className="text-sm leading-7 text-foreground-700">{article.summary}</p>
        <p className="mt-4 text-sm leading-7 text-foreground-700">
          在178漫画网，你可以免费阅读《满溢游泳池》等众多漫画的完整章节与高清画面。无需付费、无需注册，即可轻松开启你的追漫时光。无论是恋爱、校园还是治愈题材，都能在这里找到适合你的作品。
        </p>
        <p className="mt-4 text-sm leading-7 text-foreground-700">
          本站持续更新热门漫画最新章节，并通过分类、榜单与编辑推荐帮你快速发现好作品。遇到喜欢的故事，点击封面即可进入在线阅读，享受流畅的阅读体验。
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          <Link to="/category/love" className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600">
            浏览全部漫画<i className="ri-arrow-right-line"></i>
          </Link>
          <Link to="/about" className="inline-flex items-center gap-1 rounded-full bg-background-100 px-5 py-2.5 text-sm text-foreground-700 hover:bg-background-200">
            关于我们
          </Link>
        </div>
      </article>

      <div className="mt-10">
        <h3 className="font-heading text-lg text-foreground-950">相关漫画推荐</h3>
        <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {mangaList.slice(0, 4).map((m) => (
            <Link
              key={m.id}
              to={`/article/${m.slug}`}
              className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-primary-200"
            >
              <div className="aspect-[3/4] w-full overflow-hidden bg-background-100">
                <img src={m.cover} alt={`${m.title} 漫画封面`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-3">
                <p className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">{m.title}</p>
                <p className="mt-1 text-xs text-foreground-500">{m.chapters}话 · {m.rating.toFixed(1)}分</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}